// @core/api/endpoints/team/cancel_temporary_role_assignment.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CancelTemporaryRoleAssignmentRequest,
} from '../../../types/team';

const BASE_PATH = '/team';

/**
 * Cancel temporary role assignment
 * Performs cancel operation on temporary role assignment.
 */
export async function CancelTemporaryRoleAssignment(
  team_id: string,
  assignment_id: string,
  data: CancelTemporaryRoleAssignmentRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/temporary-assignments/:assignment_id/cancel`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  requestPath = requestPath.replace(':assignment_id', encodeURIComponent(assignment_id));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
